/* config/index.js 系统配置 */

const Base_Url = process.env.VUE_APP_API_URL;

const Base_Api_Url = Base_Url + "/index.php";

const Base_Upload_Url = Base_Api_Url + "/manage/common/upload";

export { Base_Url, Base_Api_Url, Base_Upload_Url };
